function getBaseURL() {
  if (location.hostname.includes('gustok.com')) {
    return 'https://gustok.com'
  }
  if (!location.hostname.includes('trovacigusto.com')) {
    return 'https://trovacigusto.mmmsolutions.studio'
  }
  return 'https://trovacigusto.com'
}

/**
 *
 *  HTTP verb.
 *  Endpoint.
 * @param method
 * @param url
 * @param data
 *  Data to be sent. It should not be json-encoded.
 * @param callback
 *  Optional callback.
 * @param preventRefresh
 * @param timeout
 * @return
 *  Deferred object.
 */
function rest (method, url, data, callback, preventRefresh, timeout) {
  if (preventRefresh) {
    return $.Deferred().promise()
  }

  // Una richiesta che la pagina ha gia' fatto partire dalla sua testa (TG_EARLY: oggi la
  // pagina di ricerca, ResourceManager::searchEarly()): se l'indirizzo e' lo stesso si usa
  // quella risposta, senza chiamare di nuovo il server. Vale una volta sola e per pochi
  // secondi; se la richiesta anticipata e' fallita si fa quella normale.
  if (method === 'GET' && window.TG_EARLY && typeof window.tgEarlyKey === 'function') {
    var earlyKey = window.tgEarlyKey(String(url))
    var early = earlyKey ? window.TG_EARLY[earlyKey] : null
    if (early) {
      delete window.TG_EARLY[earlyKey]
    }
    if (early && Date.now() - early.at < 15000) {
      var earlyDeferred = $.Deferred()
      early.promise.then(function (response) {
        if (typeof callback === 'function') {
          callback(response)
        }
        earlyDeferred.resolve(response)
      }, function () {
        rest(method, url, data, callback, preventRefresh, timeout).then(earlyDeferred.resolve, earlyDeferred.reject)
      })

      return earlyDeferred.promise()
    }
  }

  var auth_token = getCookie('auth_token')

  // Wrap the csrf token in the payload.
  var payload = {}

  if (method !== 'GET') {
    payload = {
      data: data,
      _token: csrfToken
    }
    // Encode the payload.
    payload = ko.toJSON(payload)
  } else {
    payload = { _token: csrfToken }
  }

  // This fixes trailing slashes issue with Laravel routing.
  // https://github.com/laravel/framework/issues/1438
  url.replace(/\/$/, '')
  // Check for callback.
  if (callback) {
    if (typeof (callback) === 'object') {

    }
  }

  if (location.hostname.includes('trovacigusto.mmmsolutions.studio') && window.TROVACIGUSTO) {
    timeout = 0
  }

  if (window.TROVACIGUSTO && window.TROVACIGUSTO.app_url)
    url = new URL(url, window.TROVACIGUSTO.app_url)
  else
    url = new URL(url, getBaseURL())

  // Return plain ajax return.
  return $.ajax({
    type: method,
    url: url.href,
    data: payload,
    success: callback,
    dataType: 'json',
    contentType: 'application/json; charset=utf-8',
    headers: {'X-Auth-Token': auth_token},
    cache: false,
    timeout: timeout ? timeout : 0
  }).fail(function (jqXHR, textStatus) {
    if (jqXHR.status === 401) {
      return refresh().then(function (jqXHR) {
        if (!jqXHR.success) {
          return $.Deferred().promise()
        }
        return rest(method, url, data, callback, true)
      })
    }

    return $.Deferred().fail()
  })
}

function refresh () {
  return $.post('/token/refresh', { _token: csrfToken })
}

/**
 * Una pagina precaricata dal browser (page-transitions.blade.php) viene preparata quando il
 * puntatore si ferma sul link, e aperta anche qualche minuto dopo. Se nel frattempo
 * l'utente ha cambiato qualcosa (accesso, carrello) in questa o in un'altra scheda, i suoi
 * dati scritti in quella pagina sono vecchi: restPreloaded() li scarta e li richiede.
 *
 * Come lo si sa: ogni chiamata che modifica segna l'ora in localStorage; ogni pagina lascia
 * in sessionStorage l'ora in cui e' partita. Una pagina precaricata e' stata preparata dopo
 * la partenza di quella che la precede: se da allora c'e' stata una modifica, non ci si fida.
 */
var tgPreloadStale = typeof window.tgPreloadStale === 'boolean' ? window.tgPreloadStale : (function () {
  // Questo file sta in piu' di un bundle e alcune pagine ne caricano due: il conto va fatto
  // una volta sola per pagina, perche' farlo sposta l'ora di partenza salvata.
  var stale = false

  try {
    var navigation = performance.getEntriesByType('navigation')[0]
    var previousStart = parseInt(sessionStorage.getItem('tgPageStart'), 10) || 0
    var lastChange = parseInt(localStorage.getItem('tgLastChange'), 10) || 0

    stale = !!navigation && navigation.deliveryType === 'navigational-prefetch' && lastChange >= previousStart
    sessionStorage.setItem('tgPageStart', String(Date.now()))
  } catch (e) {
    // Archivi del browser non disponibili (navigazione privata, blocchi): si resta come senza precaricamento.
  }

  return stale
})()

if (window.jQuery && !jQuery.tgChangeHookBound) {
  jQuery.tgChangeHookBound = true

  jQuery(document).ajaxSend(function (event, jqXHR, settings) {
    if (!/^(GET|HEAD|OPTIONS)$/i.test(settings.type || 'GET')) {
      try {
        localStorage.setItem('tgLastChange', String(Date.now()))
      } catch (e) {}
    }
  })
}

/**
 * Come rest('GET', url), ma se il server ha gia' messo la risposta nella pagina
 * (ResourceManager::preload -> TG_PRELOAD) restituisce quella senza chiamarlo.
 * Ogni dato si usa una volta sola: una seconda richiesta, per esempio per aggiornare
 * dopo un'azione dell'utente, va al server come sempre.
 *
 * @param key
 *  Chiave usata in ResourceManager::preload().
 * @param url
 *  Endpoint da chiamare quando il dato nella pagina non c'e'.
 * @return
 *  Deferred object.
 */
function restPreloaded (key, url) {
  var preload = window.TG_PRELOAD

  if (preload && preload[key] && tgPreloadStale && (key === 'auth' || key === 'users/bookings/drafted')) {
    delete preload[key]
  }

  if (preload && preload[key]) {
    var response = preload[key]
    var deferred = $.Deferred()
    delete preload[key]
    // Come una risposta vera, arriva dopo che il chiamante ha finito il proprio giro.
    setTimeout(function () { deferred.resolve(response) }, 0)

    return deferred.promise()
  }

  return rest('GET', url)
}

/**
 * Al posto di "window.onload = fn". Vale la stessa regola: se lo chiamano in piu' punti,
 * viene eseguita solo l'ultima funzione passata. Cambia il momento: parte appena la pagina
 * e' pronta, dopo tutti i $(document).ready, senza aspettare immagini e script esterni.
 */
function tgOnReady (fn) {
  window.tgReadyHandler = fn

  if (window.tgReadyBound) {
    return
  }
  window.tgReadyBound = true

  $(function () {
    // Un giro dopo: anche dentro un $(document).ready successivo si puo' ancora cambiare funzione.
    setTimeout(function () {
      var handler = window.tgReadyHandler
      window.tgReadyHandler = null
      if (handler) {
        handler()
      }
    }, 0)
  })
}

/**
 * Google Maps a richiesta.
 *
 * Su quasi tutte le pagine lo script di Maps e' un tag sincrono nel layout e qui non cambia
 * nulla: onReady() e ready() eseguono subito la funzione, come se non ci fossero. Sulle
 * pagine che lo chiedono (front/includes/google-maps.blade.php) il tag non c'e': al suo
 * posto il layout lascia l'indirizzo in TG_MAPS_SRC e lo script viene inserito solo quando
 * qualcuno ne ha bisogno. Li' Maps arriva DOPO gli script della pagina, quindi chi lo usa
 * non puo' toccare google.maps direttamente: passa da qui.
 *
 *   tgMaps.ready(fn)    esegue fn quando Maps c'e', e lo fa caricare se non c'e' ancora
 *   tgMaps.onReady(fn)  esegue fn quando Maps c'e', senza farlo caricare
 *   tgMaps.load()       lo fa caricare (per esempio quando si entra in un campo indirizzo)
 *
 * Questo file sta in piu' di un bundle: l'oggetto si crea una volta sola per pagina.
 */
var tgMaps = window.tgMaps || (function () {
  var queue = []
  var loading = false
  var hooked = false

  function isReady () {
    return typeof google !== 'undefined' && !!google && !!google.maps && typeof google.maps.Map === 'function'
  }

  function flush () {
    if (!isReady()) {
      return
    }
    var functions = queue
    queue = []
    for (var i = 0; i < functions.length; i++) {
      // Una mappa che non si disegna non deve fermare le altre funzioni in attesa.
      try {
        functions[i]()
      } catch (e) {
        if (window.console && console.error) {
          console.error('tgMaps:', e)
        }
      }
    }
  }

  // Google avvisa che l'API e' pronta chiamando initMap: i layout ne definiscono una vuota
  // e altri script la incatenano. Qui si fa lo stesso, una volta sola.
  function hook () {
    if (hooked) {
      return
    }
    hooked = true
    var previous = window.initMap
    window.initMap = function () {
      if (typeof previous === 'function') {
        previous.apply(this, arguments)
      }
      flush()
    }
  }

  function onReady (fn) {
    if (isReady()) {
      fn()
      return
    }
    queue.push(fn)
    hook()
  }

  function load () {
    if (loading || isReady() || !window.TG_MAPS_SRC) {
      return
    }
    loading = true
    hook()

    var script = document.createElement('script')
    script.src = window.TG_MAPS_SRC
    script.async = true
    script.onerror = function () {
      // Rete o blocco: alla prossima richiesta si riprova.
      loading = false
    }
    document.head.appendChild(script)

    // Rete di sicurezza: se qualcuno sostituisce initMap invece di incatenarla, le
    // funzioni in attesa partono lo stesso appena Maps risulta caricato.
    var checks = 0
    var timer = setInterval(function () {
      checks++
      if (isReady()) {
        clearInterval(timer)
        flush()
      } else if (checks > 150) {
        clearInterval(timer)
      }
    }, 200)
  }

  function ready (fn) {
    onReady(fn)
    load()
  }

  // Pagine dove Maps serve alla funzione principale (la ricerca per indirizzo in home): si
  // carica al primo segno di vita del visitatore, senza aspettare che entri nel campo.
  if (window.TG_MAPS_SRC && window.TG_MAPS_WARM === 'interaction' && window.addEventListener) {
    var events = ['pointerdown', 'touchstart', 'keydown', 'mousemove', 'scroll']
    var warm = function () {
      for (var i = 0; i < events.length; i++) {
        window.removeEventListener(events[i], warm, true)
      }
      load()
    }
    for (var i = 0; i < events.length; i++) {
      window.addEventListener(events[i], warm, true)
    }
  }

  return { isReady: isReady, onReady: onReady, ready: ready, load: load }
})()
window.tgMaps = tgMaps

/**
 * Legge il contenuto di un token JWT (la parte centrale), senza verificarne la firma:
 * serve solo a ricavare nome ed email dal token di Google o Apple prima di mandarlo al
 * server, che lo verifica per conto suo. Prima lo faceva la libreria jsrsasign
 * (260 KB caricati su ogni pagina per questa sola funzione).
 *
 * @param token
 * @return
 *  L'oggetto del payload, oppure null se il token non e' leggibile.
 */
function tgJwtPayload (token) {
  try {
    var part = String(token).split('.')[1].replace(/-/g, '+').replace(/_/g, '/')
    while (part.length % 4) {
      part += '='
    }
    // atob restituisce byte: vanno riletti come UTF-8, altrimenti le lettere accentate si rompono.
    var bytes = atob(part)
    var encoded = ''
    for (var i = 0; i < bytes.length; i++) {
      encoded += '%' + ('00' + bytes.charCodeAt(i).toString(16)).slice(-2)
    }
    var payload = JSON.parse(decodeURIComponent(encoded))

    return payload && typeof payload === 'object' ? payload : null
  } catch (e) {
    return null
  }
}

function getCookie (cname) {
  var name = cname + '='
  var ca = document.cookie.split(';')
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i]
    while (c.charAt(0) === ' ') c = c.substring(1)
    if (c.indexOf(name) !== -1) return c.substring(name.length, c.length)
  }
  return ''
}

function getPnotifyOptions (title, type, message, hide, timeout) {
  if (!title) {
    switch (type) {
      case 'error':
      case 'danger':
        title = 'Errore'
        type = 'error'
        break
      case 'info':
        title = 'Informazioni'
        break
      case 'notice':
      case 'warning':
        title = 'Attenzione'
        type = 'notice'
        break
      case 'success':
        title = 'OK!'
        break
      default:
        title = 'Ok!'
        break
    }
  }

  return {
    title: title,
    text: message,
    textTrusted: true,
    hide: typeof hide !== 'undefined' ? hide : true,
    type: typeof type !== 'undefined' ? type : 'success',
    delay: typeof timeout !== 'undefined' ? timeout : 5000,
    modal: false,
    sticker: false,
    closer: true,

  }
}

function getPnotifyStack (opts, name) {
  if (typeof name === 'undefined')
    return opts

  if (name === 'bottom') {
    opts.stack = new PNotify.Stack({
      dir1: 'up',
      firstpos1: 0,
      spacing1: 0
    })
    opts.addClass = 'stack-bar-bottom'
    opts.shadow = false
    opts.width = '100%'
    opts.closer = false
  }

  return opts
}

function pNotify (message, type, timeout, title, hide, stackName) {
  var opts = getPnotifyOptions(title, type, message, hide, timeout)
  opts = getPnotifyStack(opts, stackName)

  PNotify.defaultModules.set(PNotifyBootstrap3, {})
  PNotify.defaultModules.set(PNotifyFontAwesome4, {})
  PNotify.defaultModules.set(PNotifyMobile, {})

  var notice = new PNotify.alert(opts)

  /*    notice.on('click', function () {
          notice.close();
      });*/
  return notice
}